import AuthService from "./index";

// Catálogo dos relatórios disponíveis (datasets e colunas liberadas).
export async function listarDatasets() {
  const service = new AuthService();
  return service.get("/report/datasets");
}

// Roda a definição montada na tela e devolve { colunas, linhas, total, ... }.
export async function gerarRelatorio(definicao) {
  const service = new AuthService();
  return service.post("/report/run", definicao);
}

// Pede à IA a definição do relatório descrito em uma frase. Não roda nada:
// devolve só a definição, que o usuário confere no montador antes de gerar.
export async function montarDefinicaoPorFrase(frase) {
  const service = new AuthService();
  return service.post("/report/definition-from-text", { frase });
}

// Lê a mensagem que o backend mandou no corpo do erro; sem ela, usa o padrão.
export async function lerMensagemDeErro(err, padrao) {
  try {
    const corpo = await err.response.json();
    return corpo?.error || padrao;
  } catch (e) {
    return padrao;
  }
}
